var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoAlphaDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 800,
    viewBox: "0 0 475 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.917 532.333L137.25 573V166.667C137.25 153 125.917 141.667 112.25 141.667C98.5833 141.667 87.25 153 87.25 166.667V573L46.5833 532.333C36.9167 522.666 20.9167 522.666 11.25 532.333C1.58333 542 1.58333 558 11.25 567.667L94.5833 651C96.9167 653.333 99.5833 655 102.583 656.333C105.583 657.667 108.917 658.333 112.25 658.333C115.583 658.333 118.917 657.667 121.917 656.333C124.917 655 127.583 653.333 129.917 651L213.25 567.667C222.917 558 222.917 542 213.25 532.333C203.583 522.666 187.583 522.666 177.917 532.333Z",
    fill: "#D3D3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.917 373.667C316.917 378.333 331.25 371.667 335.917 358.667L345.25 332.667H412.917L422.25 358.667C425.917 369 435.583 375.333 445.917 375.333C448.583 375.333 451.583 375 454.25 374C467.25 369.333 473.917 355 469.25 342L412.25 182.334C406.583 168 393.583 158.667 378.917 158.667C364.25 158.667 351.25 168 345.583 183L288.917 342C284.25 355 290.917 369.333 303.917 374V373.667ZM394.917 282.667H362.917L378.917 238L394.917 282.667Z",
    fill: "#D3D3D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M459.583 448.667C453.25 434 439.916 425 424.583 425H320.916C307.25 425 295.916 436.333 295.916 450C295.916 463.667 307.25 475 320.916 475H400.583L306.25 573.333C294.916 585.333 291.916 602.667 298.25 618C304.583 632.667 317.916 641.667 333.25 641.667H437.583C451.25 641.667 462.583 630.333 462.583 616.667C462.583 603 451.25 591.667 437.583 591.667H357.916L451.916 494C463.25 482 466.583 464.333 459.916 449L459.583 448.667Z",
    fill: "#D3D3D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAlphaDown);
export default __webpack_public_path__ + "static/media/ico_alpha_down.51c4f8411a1560f6354ef94364ee32cf.svg";
export { ForwardRef as ReactComponent };